"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const AuthContext_1 = require("./AuthContext");
function useOAuth() {
    const { client, dispatch, state: { isSignout }, } = AuthContext_1.useAuthContext();
    const withAuthClientError = react_1.useCallback(async (fn) => {
        try {
            const result = await fn();
            return result;
        }
        catch (error) {
            dispatch({ type: 'ERROR', payload: { error } });
            throw error;
        }
    }, [dispatch]);
    return {
        isSignout,
        getAccessToken: () => {
            return withAuthClientError(async () => {
                const accessToken = await client.getAccessToken();
                if (!accessToken)
                    dispatch({ type: 'SIGN_OUT' });
                return accessToken;
            });
        },
        signIn: ({ password, username }) => {
            return withAuthClientError(async () => {
                const isSignin = await client.token({ grant_type: 'password', password, username });
                if (isSignin)
                    dispatch({ type: 'SIGN_IN', payload: { permissions: [] } });
                return isSignin;
            });
        },
        signOut: () => {
            return withAuthClientError(async () => {
                await client.revoke();
                dispatch({ type: 'SIGN_OUT' });
            });
        },
    };
}
exports.default = useOAuth;
